import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API_BASE } from "@/lib/api";

// ---------------------------------------------------------------------------
// Rastreio de visitas do site (Analytics próprio do painel).
//
// A cada troca de página, envia uma visita para o backend. Usa text/plain para
// não exigir "preflight" (CORS) e sendBeacon quando disponível, de modo que o
// envio não atrapalha nem atrasa a navegação. Falhas são ignoradas.
// ---------------------------------------------------------------------------

export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (!path) return;
    const payload = JSON.stringify({ path, referrer: document.referrer || "" });
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(
          `${API_BASE}/functions/v1/analytics`,
          new Blob([payload], { type: "text/plain" }),
        );
      } else {
        void fetch(`${API_BASE}/functions/v1/analytics`, {
          method: "POST",
          headers: { "Content-Type": "text/plain" },
          body: payload,
          keepalive: true,
        });
      }
    } catch {
      // silencioso — o rastreio nunca deve atrapalhar o site
    }
  }, [location.pathname]);

  return null;
}